import firebase from '@/firebase'
const storage = firebase.storage().ref()
const db = firebase.firestore()

const store = {
  state: {
    treeData: {},
    especiesNombresComunes: [],
    especiesLista: [],
    razasLista: []
  },
  getters: {
    getTreeData: state => {
      return state.treeData
    },
    especiesNombresComunes: state => {
      return state.especiesNombresComunes
    },
    especiesLista: state => {
      return state.especiesLista
    },
    razasLista: state => {
      return state.razasLista
    }
  },
  mutations: {
    ASIGNA_TREE_DATA(state, data) {
      state.treeData = data
    },
    ASIGNA_NOMBRES_COMUNES(state, data) {
      state.especiesNombresComunes = data
    },
    ASIGNA_ESPECIES_LISTA(state, data) {
      state.especiesLista = data
    },
    ASIGNA_RAZAS_LISTA(state, data) {
      state.razasLista = data
    }
  },
  actions: {
    restablecerValoresEspecies({commit}){
      commit('ASIGNA_TREE_DATA', {})
      commit('ASIGNA_NOMBRES_COMUNES', [])
      commit('ASIGNA_ESPECIES_LISTA', [])
    },
    subirArchivoEspecie({}, archivo) {
      return new Promise((resolve, reject) => {
        var d = new Date().getTime()
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
          var r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
        })

        var archivoSubir = uuid + '-' + archivo.name
        storage
          .child(`Especies/${archivoSubir}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                var prueba = []
                prueba[0] = url
                prueba[1] = archivoSubir
                resolve(prueba)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },
    eliminarArchivoEspecie({}, url) {
      return new Promise((resolve, reject) => {
        var storageRef = storage.child('Especies/' + url[1])
        storageRef
          .delete()
          .then(resp => {
            resolve(resp)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getTreeView({ commit, getters, dispatch }) {
      // TODO: Revisar que no se haya cargado antes
      // TODO: Revisar si es se puede cargar con onDocumentnapshot
      return new Promise((resolve, reject) => {
        db.collection('Franquicias')
          .doc(getters.franquicia.id)
          .collection('Catalogos')
          .doc('Especies')
          .get()
          .then(querySnapshot => {
            commit('ASIGNA_TREE_DATA', querySnapshot.data())
            dispatch('guardaIndicesEspecies', querySnapshot.data())
            resolve(querySnapshot.data())
            //this.treeData = querySnapshot.data();
          })
      })
    },
    obtenerNombresComunes({ getters, dispatch }) {
      return new Promise((resolve, reject) => {
        if (getters.especiesNombresComunes.length < 1) {
          dispatch('getTreeView').then(() => {
            resolve(getters.especiesNombresComunes)
          })
        } else {
          resolve(getters.especiesNombresComunes)
        }
      })
    },
    obtenerEspeciesLista({ getters, dispatch }) {
      return new Promise((resolve, reject) => {
        if (getters.especiesLista.length < 1) {
          dispatch('getTreeView').then(() => {
            resolve(getters.especiesLista)
          })
        } else {
          resolve(getters.especiesLista)
        }
      })
    },
    obtenerRazasLista({ getters, dispatch }) {
      return new Promise((resolve, reject) => {
        if (getters.razasLista.length < 1) {
          dispatch('getTreeView').then(() => {
            resolve(getters.razasLista)
          })
        } else {
          resolve(getters.razasLista)
        }
      })
    },
    guardaIndicesEspecies({ commit }, treeData) {
      //console.log('obtenNombresComunes ::')

      let nombresComunes = []
      let especiesLista = []
      const razasLista = []

      if (treeData !== undefined) {
        for (let i in treeData.children) {
          let child = treeData.children[i]
          for (let k in child.children) {
            let grandChild = child.children[k]
            for (let m in grandChild.children) {
              //console.log(grandChild.children[m])
              if (Object.keys(grandChild.children[m]).length > 0) {
                const razas = JSON.parse(JSON.stringify(grandChild.children[m].children || {} ) )
                delete grandChild.children[m].children
                nombresComunes.push(grandChild.children[m])
                for(const l in razas){
                  const raza = razas[l]
                  if(Object.keys(raza).length>4){
                    razasLista.push(raza)
                  }
                }
              }
            }
          }
          delete child.children
          especiesLista.push(child)
        }
      }
      //console.log("Razas lista ", razasLista)
      commit('ASIGNA_NOMBRES_COMUNES', nombresComunes)
      commit('ASIGNA_ESPECIES_LISTA', especiesLista)
      commit('ASIGNA_RAZAS_LISTA', razasLista)
    },

    guardarEspecie({ getters }, data) {
      db.collection('Franquicias')
        .doc(getters.franquicia.id)
        .collection('Catalogos')
        .doc('Especies')
        .set(data)
    },

    guardarEspecieTest({ getters }, data) {
      db.collection('Franquicias')
        .doc(getters.franquicia.id)
        .collection('Catalogos')
        .doc('Especies_test')
        .set(data,{merge:true})
    }
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/Especies/especies.js